import { List } from '@mui/material';

import { GDMListComponent } from './GDMList.type';

/* TODO: Implement component using GDM default design */
const GDMList: GDMListComponent = props => <List {...props} />;

export default GDMList;
